import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import useAuthStore from './store/authStore';
import AppRouter from './router';
import { ToastContainer } from './components/toast';

export default function App() {
  const loadProfile = useAuthStore((s) => s.loadProfile);

  useEffect(() => {
    const token = localStorage.getItem('mkt_token');
    if (token) {
      loadProfile();
    } else {
      useAuthStore.setState({ loading: false });
    }
  }, [loadProfile]);

  return (
    <BrowserRouter>
      <AppRouter />
      <ToastContainer />
    </BrowserRouter>
  );
}
